var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueMappin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 0.33339C4.59789 0.323263 3.24898 0.869658 2.24916 1.85273C1.24934 2.8358 0.680243 4.17529 0.666687 5.57739C0.696557 6.91353 1.20901 8.1937 2.10935 9.18139L2.59069 9.76006C3.56802 10.9354 5.55669 13.3274 5.74069 13.5461C5.77254 13.5838 5.81225 13.6141 5.85704 13.635C5.90183 13.6558 5.95063 13.6665 6.00002 13.6665C6.04941 13.6665 6.09821 13.6558 6.143 13.635C6.18779 13.6141 6.2275 13.5838 6.25935 13.5461C6.44335 13.3274 8.43202 10.9354 9.40935 9.76006L9.89069 9.18206C10.7912 8.1942 11.3036 6.91376 11.3334 5.57739C11.3198 4.17529 10.7507 2.8358 9.75088 1.85273C8.75106 0.869658 7.40215 0.323263 6.00002 0.33339ZM6.00002 7.66672C5.60446 7.66672 5.21778 7.54943 4.88888 7.32966C4.55998 7.1099 4.30364 6.79754 4.15226 6.43209C4.00089 6.06664 3.96128 5.66451 4.03845 5.27654C4.11562 4.88858 4.3061 4.53222 4.58581 4.25251C4.86551 3.97281 5.22188 3.78232 5.60984 3.70515C5.9978 3.62798 6.39993 3.66759 6.76539 3.81896C7.13084 3.97034 7.4432 4.22669 7.66296 4.55558C7.88272 4.88448 8.00002 5.27116 8.00002 5.66672C8.00002 6.19716 7.78931 6.70587 7.41423 7.08094C7.03916 7.45601 6.53045 7.66672 6.00002 7.66672Z",
    fill: "#0276B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMappin);
export default __webpack_public_path__ + "static/media/blueMappin.da4fe2bde723cc50d6589d972aa3f76d.svg";
export { ForwardRef as ReactComponent };